import './index.css';
import { useContext, useEffect } from 'react';
import { isSameDay, isBefore, isAfter } from 'date-fns';
import { AsyncDataContext } from './AsyncDataContext.js';

const useDisabledDatesFunc = (startDate, endDate, disabledDates, minDate, maxDate) => {
    const asyncDataContext = useContext(AsyncDataContext);
    useEffect(() => {
        if (asyncDataContext !== null && !asyncDataContext.hasData(startDate, endDate)) {
            asyncDataContext.startAsyncLoading(startDate, endDate);
        }
    }, [asyncDataContext, startDate, endDate]);
    return (date) => (disabledDates !== undefined && disabledDates.some((disabledDate) => isSameDay(disabledDate, date))) ||
        (asyncDataContext !== null &&
            asyncDataContext.disabledDates.some((disabledDate) => isSameDay(disabledDate, date))) ||
        (minDate !== undefined && isBefore(date, minDate)) ||
        (maxDate !== undefined && isAfter(date, maxDate));
};

export { useDisabledDatesFunc };
//# sourceMappingURL=useDisabledDatesFunc.js.map
